import { render, staticRenderFns } from "./ModalAgendamentos.vue?vue&type=template&id=a0fe183a&scoped=true"
import script from "./ModalAgendamentos.vue?vue&type=script&lang=js"
export * from "./ModalAgendamentos.vue?vue&type=script&lang=js"
import style0 from "./ModalAgendamentos.vue?vue&type=style&index=0&id=a0fe183a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fe183a",
  null
  
)

export default component.exports